import { lazy } from 'react';

// Lazy-loaded public components
export const LayoutNotAuth = lazy(
  () => import('@hub/components/layout-not-auth/layout-not-auth-nova'),
);
export const Login = lazy(() => import('@hub/features/login/login-nova'));
export const Register = lazy(
  () => import('@hub/features/register/register-nova'),
);
export const OtpLoginPage = lazy(
  () => import('@hub/features/otp-login-page/otp-login-page'),
);
export const PublicTradeTalk = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.PublicTradeTalk,
  })),
);
export const TradeTalks = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.TradeTalks,
  })),
);
export const Article = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.Article,
  })),
);
